<template>
  <div class="input-file">
    <input type="file" ref="input" class="visually-hidden" @change="change" />
    <span class="button" @click="$refs.input.click()">{{ buttonText }}</span>
    <span v-if="file && file.name" class="input-file__name">{{ file.name }}</span>
  </div>
</template>

<script>
export default {
  name: 'VInputFile',

  data() {
    return {
      file: null
    }
  },

  computed: {
    buttonText() {
      if (this.file) return this.$t('c.input.buttonChangeFile')
      return this.$t('c.input.buttonSelectFile')
    }
  },

  methods: {
    clear() {
      this.file = null
      this.$refs.input.value = ''
    },

    change(event) {
      const { files } = event.target
      const file = files && files.length ? files[0] : null

      if (!file) {
        this.file = null
        return
      }

      const fileObject = {
        name: file.name,
        raw: file,
        size: file.size
      }

      this.file = fileObject
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/style/scss/_vars.scss";
@import "@/assets/style/scss/_extends.scss";

.input-file {
  @extend %flex-row;
  align-items: center;
}
.input-file__name {
  padding: 0 $padding-base * 1.4;
}
</style>
